module.exports = __webpack_public_path__ + "static/media/tool-card-6-icon.f678a2b4.svg";